<script setup lang="ts">
import { Well } from '@wision/ui';
import type { SensorViewValues, SensorValue } from '../../models/sensorViewValues';
import { computed } from 'vue';
import type { PropType } from 'vue';

const props = defineProps({
  viewValues: {
    type: Object as PropType<SensorViewValues>,
    required: true,
  },
});

const state = computed(() => {
  const levels = props.viewValues
    .values
    .filter((v: SensorValue) => v.type === 'switch');

  const activeLevel = levels.findLastIndex((v: SensorValue) => ((v?.value as number) ?? 0) > 0);
  return {
    level: activeLevel + 1,
    levles: levels.length
  };
});

</script>

<template>
  <div class="fixed left-0 top-0 bottom-0 w-[100vw] z-0 m-auto">
    <Well 
      :level="state.level" 
      :sand="true" 
      :levels="viewValues.values
        .filter(val => val.type === 'switch')
        .map(val => ({ name: val.name ?? '', active: val.value ? (val.value as number) > 0 : false }))" />
  </div>
</template>
